import { createContext, useContext, useEffect, useState } from 'react';
import { API_PATCH, DBRequest, useConfig } from '../api/api';

const UserPreferencesContext = createContext({
  preferences: null,
  updatePreferences: () => {},
});

export const UserPreferencesProvider = ({ children }) => {
  const config = useConfig();
  const [preferences, setPreferences] = useState(null);

  useEffect(() => {
    DBRequest({
      config,
      path: `userpreferences/own`,
      onResponse: (res) => {
        setPreferences(res.data?.additionalOptions || {});
      },
    });
  }, [config]);

  const updatePreferences = (key, value, deconstruct) => {
    const newAdditionalOptions = deconstruct
      ? { ...preferences, ...value }
      : {
          ...preferences,
          [key]: value,
        };

    DBRequest({
      config,
      path: `userpreferences/own`,
      method: API_PATCH({ additionalOptions: newAdditionalOptions }),
      onResponse: (res) => {
        setPreferences(res.data?.additionalOptions || {});
      },
    });
  };

  return (
    <UserPreferencesContext.Provider value={{ preferences, updatePreferences }}>
      {children}
    </UserPreferencesContext.Provider>
  );
};

export const useUserPreferences = () => useContext(UserPreferencesContext);
